import { history } from "./history";
import { SCREEN_PATHS } from "./paths";

/**
 * Parameters a payment provider appends to the redirect URL when the payer
 * comes back from the bank (PIS consent authorisation, successful or not).
 */
const CALLBACK_PARAM_KEYS = ["code", "state", "error", "error_description", "status", "id"];

const getCallbackParams = (raw?: string) => {
  const params = (raw ?? "").replace(/^[#?]/, "");

  if (!params) return null;

  const parsed = new URLSearchParams(params);

  return CALLBACK_PARAM_KEYS.some((key) => parsed.has(key)) ? params : null;
};

/**
 * Banks only redirect to whitelisted URLs. Where only the app root is
 * whitelisted, `API.REDIRECT_PATH_PAYMENT_COMPLETE` is left empty and the
 * consent callback lands on `/` instead of `/paymentcomplete`, with the
 * authorisation params in the fragment (or, for some providers, the query).
 *
 * This forwards such a callback to the payment complete screen, always as a
 * fragment, since `RTPCompletePaymentScreen` reads them from `location.hash`.
 *
 * Must be called before the app renders.
 */
export const handlePaymentCompleteCallback = () => {
  const { pathname, search, hash } = history.location;

  if (pathname !== "/") return;

  const params = getCallbackParams(hash) ?? getCallbackParams(search);

  if (!params) return;

  history.replace({ pathname: SCREEN_PATHS.PAYMENT_COMPLETE, hash: `#${params}` });
};
